var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolicySummaryReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.7891 175V339.062H175H291.211V203.984V69.043L262.09 39.9219L233.105 10.9375H145.879H58.7891V175ZM222.852 51.9531V79.2969H250.195H277.539V202.344V325.391H175H72.4609V175V24.6094H147.656H222.852V51.9531ZM252.246 50.5859L267.285 65.625H251.836H236.523V50.5859C236.523 42.2461 236.66 35.5469 236.934 35.5469C237.07 35.5469 244.043 42.2461 252.246 50.5859Z",
    fill: "#A200FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9688 103.223V127.148H116.895H140.82V103.223V79.2969H116.895H92.9688V103.223ZM127.148 103.223V113.477H116.895H106.641V103.223V92.9688H116.895H127.148V103.223Z",
    fill: "#A200FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.492 92.9688V99.8047H181.836H209.18V92.9688V86.1328H181.836H154.492V92.9688Z",
    fill: "#A200FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M154.492 120.312V127.148H205.762H257.031V120.312V113.477H205.762H154.492V120.312Z",
    fill: "#A200FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9688 164.746V188.672H116.895H140.82V164.746V140.82H116.895H92.9688V164.746ZM127.148 164.746V175H116.895H106.641V164.746V154.492H116.895H127.148V164.746Z",
    fill: "#A200FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M154.492 154.492V161.328H181.836H209.18V154.492V147.656H181.836H154.492V154.492Z",
    fill: "#A200FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154.492 181.836V188.672H205.762H257.031V181.836V175H205.762H154.492V181.836Z",
    fill: "#A200FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9688 226.27V250.195H116.895H140.82V226.27V202.344H116.895H92.9688V226.27ZM127.148 226.27V236.523H116.895H106.641V226.27V216.016H116.895H127.148V226.27Z",
    fill: "#A200FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M154.492 216.016V222.852H181.836H209.18V216.016V209.18H181.836H154.492V216.016Z",
    fill: "#A200FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M154.492 243.359V250.195H205.762H257.031V243.359V236.523H205.762H154.492V243.359Z",
    fill: "#A200FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9688 287.793V311.719H116.895H140.82V287.793V263.867H116.895H92.9688V287.793ZM127.148 287.793V298.047H116.895H106.641V287.793V277.539H116.895H127.148V287.793Z",
    fill: "#A200FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M154.492 277.539V284.375H181.836H209.18V277.539V270.703H181.836H154.492V277.539Z",
    fill: "#A200FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M154.492 304.883V311.719H205.762H257.031V304.883V298.047H205.762H154.492V304.883Z",
    fill: "#A200FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicySummaryReport);
export default __webpack_public_path__ + "static/media/PolicySummaryReport.f99373468155cbb049aeb974e77f4542.svg";
export { ForwardRef as ReactComponent };